<template>
  <transition-group
    enter-active-class="ease-in-out duration-500"
    enter-class="opacity-0"
    enter-to-class="opacity-100"
    leave-active-class="ease-in-out duration-500"
    leave-class="opacity-100"
    leave-to-class="opacity-0"
  >
    <div
      v-show="active"
      @click="$emit('close')"
      class="bg-ontick-carbon-500 fixed inset-0 z-40 bg-opacity-50 transition-opacity"
      aria-hidden="true"
      key="1"
    ></div>

    <div
      v-show="active"
      class="fixed inset-y-0 right-0 z-50 flex max-w-full"
      key="2"
    >
      <transition
        enter-active-class="transform transition ease-in-out duration-500 sm:duration-700"
        enter-class="translate-x-full"
        enter-to-class="translate-x-0"
        leave-active-class="transform transition ease-in-out duration-500 sm:duration-700"
        leave-class="translate-x-0"
        leave-to-class="translate-x-full"
      >
        <div v-show="active" class="w-screen" :class="`max-w-${size}`">
          <div
            class="dark:bg-ontick-carbon-500 flex h-full flex-col overflow-y-scroll bg-gray-50 bg-opacity-75 shadow-xl backdrop-blur-sm backdrop-opacity-90 backdrop-filter"
          >
            <div
              class="dark:bg-ontick-carbon-500 sticky top-0 bg-gray-50 px-6 py-3 pr-14 shadow-lg"
            >
              <div class="flex items-center space-x-4">
                <div class="">
                  <button
                    @click="$emit('close')"
                    class="text-ontick-steel-900 py-1 hover:text-gray-400 focus:outline-none dark:text-gray-400"
                  >
                    <span v-html="$icons.arrow_left" />
                  </button>
                </div>
                <span class="font-bold">{{ title }}</span>
              </div>
            </div>
            <div class="p-6">
              <slot />
            </div>
          </div>
        </div>
      </transition>
    </div>
  </transition-group>
</template>

<script>
export default {
  components: {},

  props: {
    active: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: "md",
      validator: (val) => {
        return ["md", "lg", "xl", "2xl"].includes(val);
      },
    },
    title: {
      type: String,
    },
  },
};
</script>
